import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { usePermission } from '../../hooks/usePermission'

/**
 * 顧客姓名 → 顧客詳情頁的連結。
 *
 * 結帳頁、結帳紀錄都要用，所以抽出來共用。顯示成純文字的情況：
 *   1. 沒有 customerId（現場結帳還沒選顧客、舊訂單沒綁顧客檔）；
 *   2. 沒有 customer:view 權限 —— 點進去只會看到無權限頁，不如不給連結。
 *
 * customerId 可能是 populate 過的物件（後端 getOrders 會 populate customer.customerId），
 * 這裡統一取 _id，避免連到 /customers/[object Object]。
 *
 * newTab：結帳頁正在填的資料不能因為點了姓名就不見，所以結帳頁要開新分頁；
 * 結帳紀錄頁的篩選條件都記在網址上，按上一頁就回得來，直接切換即可。
 */

const StyledLink = styled(Link)`
  color: inherit;
  font-weight: inherit;
  text-decoration: underline;
  text-decoration-color: rgba(213, 114, 138, 0.45);
  text-underline-offset: 3px;
  transition: color 0.15s ease, text-decoration-color 0.15s ease;

  &:hover {
    color: #d5728a;
    text-decoration-color: #d5728a;
  }
`

export const resolveCustomerId = (value) => {
  if (!value) return ''
  if (typeof value === 'object') return value._id ? String(value._id) : ''
  return String(value)
}

const CustomerNameLink = ({ customerId, children, newTab = false }) => {
  const { can } = usePermission()
  const id = resolveCustomerId(customerId)

  if (!id || !can('customer:view')) return <>{children}</>

  return (
    <StyledLink
      to={`/customers/${id}`}
      title='查看顧客資料'
      // 結帳紀錄的卡片本身可能有點擊行為，連結不要把事件往上冒
      onClick={(e) => e.stopPropagation()}
      {...(newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {children}
    </StyledLink>
  )
}

export default CustomerNameLink
